<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    [showBackBtn]="false"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <div class="app-page-content tw-flex-center">
    <!-- form -->
    <div class="2xl:tw-w-3/4 xl:tw-w-11/12 md:tw-w-3/4">
      <mat-stepper linear #stepper (selectionChange)="onChangeStep($event)">
        <!-- step1 Domain Info -->
        <mat-step [stepControl]="domainInfoForm">
          <!-- form -->
          <form [formGroup]="domainInfoForm">
            <!-- step name -->
            <ng-template matStepLabel>{{
              pageVocabs + "domainInfo" | translate
            }}</ng-template>

            <!-- domain Info -->
            <div
              class="tw-my-10 2xl:tw-mx-20 xl:tw-mx-12 tw-mx-5 tw-grid xl:tw-grid-cols-3 tw-grid-cols-1"
            >
              <div
                class="tw-grid tw-grid-cols-1 tw-col-span-2 tw-gap-y-3 xl:tw-order-1 tw-order-2"
              >
                <!-- group-price-category -->
                <group-price-category-select-search
                  [id]="currentUserInfo?.organizationId"
                  [control]="domainInfoForm?.get('defaultGroupPriceCategoryId')"
                  [value]="model.defaultGroupPriceCategoryId"
                  (valueChange)="
                    model.defaultGroupPriceCategoryId = $event;
                    model.defaultGroupPriceId = null
                  "
                  (isShowGroupPrice)="isShowGroupPrice = $event"
                  (onError)="onClose()"
                >
                </group-price-category-select-search>

                <!-- group-price-id -->
                <group-price-select-search
                  [isShowGroupPrice]="isShowGroupPrice"
                  [id]="
                    isShowGroupPrice ? model.defaultGroupPriceCategoryId : null
                  "
                  [isDisabled]="!model.defaultGroupPriceCategoryId"
                  [control]="domainInfoForm?.get('defaultGroupPriceId')"
                  [value]="
                    model.defaultGroupPriceCategoryId
                      ? model.defaultGroupPriceId
                      : ''
                  "
                  (valueChange)="model.defaultGroupPriceId = $event"
                  (onError)="onClose()"
                >
                </group-price-select-search>

                <!-- header -->
                <div>
                  <span class="tw-text-[16px] tw-text-gray-500 tw-font-light"
                    >{{ "common.domainHeader" | translate }}
                  </span>

                  <!-- editor -->
                  <div
                    class="tw-border tw-border-[#9e9e9e] tw-rounded-[4px] mt-2 tw-min-h-[26px]"
                  >
                    <div #editor></div>
                  </div>
                </div>
              </div>

              <!-- logo Uploader -->
              <div
                class="tw-flex-center tw-flex-col xl:tw-order-2 tw-order-1 xl:tw-mb-0 tw-mb-6"
              >
                <image-uploader
                  (imgSrc)="model.logoSrc = $event"
                  [imageSrc]="model?.logoSrc"
                  imageUploaderTitle="common.logoUpload"
                  imageUploaderSize="xl:tw-h-64 xl:tw-w-64 lg:tw-w-56 lg:tw-h-56 tw-h-48 tw-w-48"
                ></image-uploader>

                <!-- agent logo title -->
                <span
                  class="tw-font-extrabold tw-text-lg tw-text-primary-800 dark:tw-text-primary-300 tw-mt-4"
                  >{{ pageVocabs + "fields.agentLogo" | translate }}</span
                >
              </div>
            </div>

            <!-- next level btn -->
            <div class="tw-w-full tw-flex tw-justify-center tw-mb-3">
              <button
                [disabled]="!isValidResellerDomainForms()"
                type="button"
                mat-ripple
                matStepperNext
                class="btn tw-w-[150px] tw-mr-[5px] ltr:tw-ml-[5px] button-shadow btn-hover-rise tw-flex-center"
                [themeColor]="'btn'"
              >
                <span> {{ "common.nextLevel" | translate }}</span>
                <i
                  class="mdi mdi-arrow-left text-white tw-mx-2"
                  style="font-size: 20px !important"
                ></i>
              </button>
            </div>
          </form>
        </mat-step>

        <!-- step2 Choose Template -->
        <mat-step [stepControl]="chooseTemplateForm">
          <!-- form -->
          <form [formGroup]="chooseTemplateForm">
            <!-- step label -->
            <ng-template matStepLabel>{{
              "common.chooseTemplate" | translate
            }}</ng-template>

            <div class="tw-mx-4 tw-flex-center tw-flex-col tw-mt-10">
              <!-- desktop -->
              <div class="xl:tw-w-2/5 md:tw-w-2/3 tw-w-full tw-my-2">
                <enum-select-search
                  enumName="Desktop"
                  [label]="fields + 'desktop'"
                  [control]="chooseTemplateForm?.get('desktop')"
                  [(value)]="model.desktop"
                  (onError)="onClose()"
                >
                </enum-select-search>
              </div>

              <!-- login Page Mode -->
              <div class="tw-mb-5 tw-mt-14 tw-flex-center tw-flex-col">
                <!-- Selected login page label -->
                <span
                  class="tw-font-medium tw-text-lg tw-text-primary-800 dark:tw-text-primary-300"
                  >{{ "messages.selectedLoginPageTemplate" | translate }}
                </span>

                <!-- login Page Mode Img -->
                <div
                  class="tw-col-span-2 tw-grid xl:tw-grid-cols-3 tw-gap-6 tw-mt-9 tw-w-full"
                >
                  <div
                    *ngFor="let img of loginPageModeImg"
                    class="tw-relative tw-flex-center tw-flex-col"
                  >
                    <!-- image -->
                    <img
                      [src]="img.src"
                      [alt]="img.alt"
                      class="2xl:tw-h-64 xl:tw-h-48 tw-h-64 tw-w-full tw-cursor-pointer tw-rounded-lg"
                      (click)="onSelectLoginPageMode(img.name)"
                      [ngClass]="
                        model?.loginPageMode == img.name
                          ? 'border-primary tw-bg-[#f4f5ff91] dark:tw-bg-[#111a31] tw-border-2'
                          : 'tw-bg-gray-50 dark:tw-border-dark-100 dark:tw-bg-dark-200 tw-border'
                      "
                    />

                    <!-- selected icon -->
                    <div
                      *ngIf="model?.loginPageMode == img.name"
                      class="tw-flex-center tw-h-12 tw-w-12 -tw-top-5 tw-absolute tw-bg-white dark:tw-bg-dark-500 tw-rounded-full tw-border-2 border-primary"
                    >
                      <i class="mdi mdi-check mdi-30px text-primary"></i>
                    </div>

                    <!-- Login Page Mode name -->
                    <h4
                      class="tw-font-medium tw-mt-3 tw-py-4 tw-text-[15px]"
                      [ngClass]="
                        model?.loginPageMode == img.name
                          ? 'text-primary'
                          : 'tw-text-gray-700 dark:tw-text-gray-400'
                      "
                    >
                      {{ img.name | enumToText : LoginPageModesEnumValues }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>

            <!-- next level btn -->
            <div class="tw-w-full tw-flex tw-justify-center tw-my-4">
              <button
                type="button"
                mat-ripple
                matStepperNext
                class="btn tw-w-[150px] tw-mr-[5px] ltr:tw-ml-[5px] button-shadow btn-hover-rise tw-flex-center"
                [themeColor]="'btn'"
              >
                <span> {{ "common.nextLevel" | translate }}</span>
                <i
                  class="mdi mdi-arrow-left text-white tw-mx-2"
                  style="font-size: 20px !important"
                ></i>
              </button>
            </div>
          </form>
        </mat-step>

        <!-- step 3 selected Theme -->
        <mat-step [stepControl]="form">
          <form [formGroup]="form">
            <!-- step label -->
            <ng-template matStepLabel>{{
              "common.chooseTheme" | translate
            }}</ng-template>

            <div class="tw-flex-center tw-flex-col tw-mx-4 tw-my-10">
              <!-- dashboardMode -->
              <div class="xl:tw-w-1/2 md:tw-w-3/4 tw-w-full tw-my-2">
                <enum-select-search
                  class="tw-w-full"
                  enumName="DashboardModes"
                  [label]="fields + 'dashboardMode'"
                  [control]="form?.get('dashboardMode')"
                  [(value)]="model.dashboardMode"
                  (onError)="onClose()"
                >
                </enum-select-search>
              </div>

              <!-- primaryColor -->
              <div class="xl:tw-w-1/2 md:tw-w-3/4 tw-w-full tw-my-2">
                <enum-select-search
                  class="tw-w-full"
                  enumName="Colors"
                  [label]="fields + 'primaryColor'"
                  [control]="form?.get('primaryColor')"
                  [(value)]="model.primaryColor"
                  (onError)="onClose()"
                >
                </enum-select-search>
              </div>

              <!-- secondaryColor -->
              <div class="xl:tw-w-1/2 md:tw-w-3/4 tw-w-full tw-my-2">
                <enum-select-search
                  class="tw-w-full"
                  enumName="Colors"
                  [label]="fields + 'secondaryColor'"
                  [control]="form?.get('secondaryColor')"
                  [(value)]="model.secondaryColor"
                  (onError)="onClose()"
                >
                </enum-select-search>
              </div>
            </div>

            <!-- next level btn -->
            <div class="tw-w-full tw-flex tw-justify-center tw-my-4">
              <button
                type="button"
                mat-ripple
                matStepperNext
                class="btn tw-w-[150px] tw-mr-[5px] ltr:tw-ml-[5px] button-shadow btn-hover-rise tw-flex-center"
                [themeColor]="'btn'"
              >
                <span> {{ "common.nextLevel" | translate }}</span>
                <i
                  class="mdi mdi-arrow-left text-white tw-mx-2"
                  style="font-size: 20px !important"
                ></i>
              </button>
            </div>
          </form>
        </mat-step>

        <!-- step4 -->
        <mat-step>
          <ng-template matStepLabel>{{
            "common.imageUpload" | translate
          }}</ng-template>

          <div class="tw-w-full">
            <div
              class="alert tw-bg-gray-50 dark:tw-bg-dark-200 border tw-mb-2 tw-h-full tw-w-full tw-mt-8"
            >
              <span class="tw-font-semibold text-navyBlue tw-text-lg">
                {{ "common.help" | translate }}
              </span>
              <div class="tw-flex-center xl:tw-flex-row tw-flex-col">
                <div
                  class="tw-text-sm xl:tw-w-3/5 tw-w-full"
                  [innerHTML]="
                    model?.loginPageMode == LoginPageModes.LoginWithCarousel
                      ? ('components.domainForm.imageUploaderHelpForLoginWithCarousel'
                        | translate)
                      : ('components.domainForm.imageUploaderHelpForRightOrCenterLogin'
                        | translate)
                  "
                ></div>
                <img
                  class="xl:tw-w-2/5 md:tw-w-4/5 tw-w-full tw-h-56"
                  [src]="
                    model?.loginPageMode != LoginPageModes.LoginWithCarousel
                      ? '/assets/media/login-page-mode/bg-image/right-or-center-login.png'
                      : '/assets/media/login-page-mode/bg-image/login-with-carousel.png'
                  "
                  alt="bgImage"
                />
              </div>
            </div>

            <div class="tw-flex-center tw-py-8 tw-h-full tw-w-full">
              <!-- center Login and right Login background image uploader-->
              <div
                *ngIf="
                  model?.loginPageMode != LoginPageModes.LoginWithCarousel;
                  else loginWithCarousel
                "
              >
                <image-uploader
                  (imgSrc)="model.backgroundImagePath = $event"
                  [imageSrc]="model?.backgroundImagePath"
                  imageUploaderTitle="common.uploadBackground"
                  imageUploaderSize="xl:tw-h-96 xl:tw-w-96 lg:tw-w-56 lg:tw-h-56 tw-h-48 tw-w-48"
                ></image-uploader>
              </div>

              <!--upload image for login With Carousel-->
              <ng-template #loginWithCarousel>
                <div
                  class="tw-grid xl:tw-grid-cols-3 md:tw-grid-cols-2 tw-grid-cols-1 tw-gap-8"
                >
                  <ng-container
                    *ngFor="
                      let pic of model?.sliderPicturePaths;
                      let index = index
                    "
                  >
                    <image-uploader
                      (imgSrc)="addSliderPicture($event)"
                      [imageSrc]="pic"
                      imageUploaderTitle="common.uploadImage"
                      (isClickOnAddBtn)="addImageUploaderField()"
                      (isClickOnDeleteBtn)="deleteImageUploaderField(index)"
                      [isShowAddBtn]="
                        index == model.sliderPicturePaths.length - 1
                          ? true
                          : false
                      "
                      imageUploaderSize="xl:tw-h-80 xl:tw-w-80 md:tw-w-72 md:tw-h-72 tw-h-80 tw-w-80"
                    ></image-uploader>
                  </ng-container>
                </div>
              </ng-template>
            </div>
          </div>
        </mat-step>
      </mat-stepper>

      <!-- form btns-->
      <div *ngIf="currentStep == 3">
        <app-form-btns
          [loading]="loading"
          [isEdit]="true"
          [showCloseBtn]="false"
          (onSubmit)="onSubmit()"
        >
        </app-form-btns>
      </div>
    </div>
  </div>
</app-page-body>
